import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import {Alert} from '@mui/material';


const MakeAdmin = () => {
    const [email, setEmail] = useState('');
    const [success, setSuccess] = useState(false);

    const handleAdminSubmit = e => {
        const user = { email }
        fetch('https://fierce-dusk-72833.herokuapp.com/users/admin', {
            method: 'PUT',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(user)
        })
            .then(res => res.json())
            .then(result => {
                if (result.modifiedCount) {
                    alert('Added As Admin')
                    console.log(result)
                    setSuccess(true)
                }
            })
        e.preventDefault();
    }
    const handleOnBlur = e => {
        setEmail(e.target.value)
    }
    return (
        <div>
            <h2>Make Admin</h2>
            <form onSubmit={handleAdminSubmit}>
                <TextField
                    sx={{ width: '50%' }}
                    label="Email"
                    type="email"
                    onBlur={handleOnBlur}
                    variant="standard" />
                <Button type="submit" variant="contained">Make Admin</Button>
                {success && <Alert severity="success">Add Admin Successfully</Alert>}
            </form>
        </div>
    );
};

export default MakeAdmin;